module.exports = __webpack_public_path__ + "static/media/GTBLogo.fab54f7f.svg";